var React = require('react');

function TextbuttonArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 7L53.5 7","stroke":"currentColor","strokeWidth":"3","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M53.5 1.74104V12.259C53.5 13.0308 54.3372 13.5116 55.0039 13.1227L64.0192 7.86378C64.6807 7.4779 64.6807 6.5221 64.0192 6.13622L55.0039 0.877258C54.3372 0.488375 53.5 0.969246 53.5 1.74104Z","fill":"currentColor","key":1})]);
}

TextbuttonArrow.defaultProps = {"width":"65","height":"14","viewBox":"0 0 65 14","fill":"none"};

module.exports = TextbuttonArrow;

TextbuttonArrow.default = TextbuttonArrow;
